<template>
  <div>

    <div class="container  titleContainer">
      <div class="row">
        <div class="col-md-5 col-sm-9 createCardTitleWrapper">
          <b-card id="createCardTitle">
            <b-button v-ripple.400="'rgba(255, 159, 67, 0.15)'" variant="none" to="/assets/source-list" v-b-tooltip.hover
              title="Go Back to the Search List" class="d-inline text-warning">
              <feather-icon icon="ArrowLeftCircleIcon" size="25" />
            </b-button>
            <h4 class="d-inline text-center font-weight-bolder">Update {{ title }} </h4>
          </b-card>
        </div>
      </div>
    </div>
    <b-card id="createCardForm">
      <div class="container">
        <form @submit.prevent="updateCode">
          <div class="row justify-content-center">
            <div class="col-md-10 my-1">
              <b-form-group label="Title">
                <b-form-input v-model="title" required placeholder="Enter a title for the code source"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-10 my-1">
              <b-form-textarea v-model="description" rows="4" required
                placeholder="Enter a description"></b-form-textarea>
            </div>

            <div class="col-md-10 my-1">
              <b-form-group label="ZIP File">
                <b-form-file v-model="zipFiles" accept=".rar,.zip" placeholder="Choose a ZIP file"></b-form-file>
                <small class="form-text text-muted">Accepted formats: ZIP</small>
              </b-form-group>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-md-10 mb-2">
              <b-form-group label="List of Apps Associated with this code (Choose from available Package names)">
                <v-select v-model="appsid" :options="appsidlist" multiple></v-select>
              </b-form-group>

            </div>


            <div class="col-md-3">
              <b-button type="submit" variant="outline-success" block>Update</b-button>
            </div>
          </div>
        </form>
      </div>
    </b-card>

    <div class="loader-overlay" v-if="isLoading">
      <b-spinner label="Loading..." style="width: 6rem; height: 6rem;" variant="success" />
    </div>
  </div>
</template>

<script>
import {
  BCard,
  VBTooltip,
  BButtonGroup,
  BFormGroup,
  BFormSelect,
  BInputGroup,
  BFormInput,
  BLink,
  BButton,
  BSpinner,
  BModal,
  VBModal,
  BFormFile,
  BFormTextarea,
  BFormTags,
} from "bootstrap-vue";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Ripple from "vue-ripple-directive";
import router from "@/router";
import store from "@/store";
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';

export default {
  components: {
    BFormTextarea,
    BLink,
    'b-tooltip': VBTooltip,
    BCard,
    BFormTags,
    'v-select': vSelect,
    BButtonGroup,
    BSpinner,
    BFormGroup,
    BFormSelect,
    BFormFile,
    BInputGroup,
    BFormInput,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BModal,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      id: null,
      title: '',
      description: '',
      appsid: [],
      zip_url: '',
      zipFiles: null,
      appsidlist: ["com.firefox.top", "amd.core.alt", "beta.threads.engine", "test.testing.test", "making.stuff.up"],
      selectedApps: [],
      searchText: '',
      isLoading: false,
    }
  },

  mounted() {
    this.id = this.$route.params.id;
    this.user_token = JSON.parse(localStorage.getItem("accessToken"));
    this.getSource();

  },

  methods: {
    getSource() {
      try {
        axios.get(`/assets/code/${this.id}`)
          .then(({ data }) => {
            this.title = data.script.title;
            this.description = data.script.description;
            let appsId = JSON.parse(data.script.apps_id);
            let splitAppsId = appsId[0].split(',');
            this.appsid = splitAppsId
          })
      } catch (error) {

      }
    },
    showToast(variant, icon, title, text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title,
          icon,
          text,
          variant,
        },
      });
    },
    updateCode() {
      try {
        var formData = new FormData();
        formData.append("title", this.title);
        formData.append("id", this.id);
        formData.append("description", this.description);
        formData.append("user_token", this.user_token);
        formData.append("appsId[]", this.appsid);
        if (this.zipFiles) {
          formData.append("zip_file", this.zipFiles);
        }
        this.isLoading = true
        axios.post('/assets/code/update', formData)
          .then(({ data }) => {
            if (data.status == "success") {
              this.isLoading = false
              this.showToast(
                "success",
                "SaveIcon",
                "Success",
                data.message
              );
              router.push({ name: 'am-assets-source' })
            } else if (data.status == "failed") {
              this.showToast(
                "danger",
                "AlertTriangleIcon",
                "Error",
                data.message
              );
              this.isLoading = false

            }
          })
          .catch((error) => {
            this.isLoading = false

            this.showToast(
              "danger",
              "AlertTriangleIcon",
              "Error",
              error
            );
          });
      } catch (error) {
        this.isLoading = false
        console.error('Error uploading files:', error);
      }

    },
  },
  watch: {

  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
<style scoped>
#createCardTitle,
#createCardForm,
.createCardTitleWrapper,
[dir] .card,
.titleContainer {
  margin: 0 !important;

}



#createCardTitle,
#createCardForm {
  border-radius: 0 !important;
}

div.app-content.content>div.content-wrapper>div>div>div.container.titleContainer>div>div {
  padding: 0;
}

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(8px);
  /* Add blur effect to the background */
}

/* Center the spinner */
.loader-overlay .spinner-grow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.custom-editor {
  height: 20vh;
}

.v-select {
  border: 0.5px solid #8c8c8ce0;
}

.v-select:focus {
  border: 0.5px solid #0e5fbce0;
}
</style>